import $ from 'jquery';
import BackgroundImage from './BackgroundImage';
import 'slick-carousel';

const defaults = {
  speed: 1000,
  fade: true,
  dots: true,
  arrows: false,
  waitForAnimate: false,
};

export default class Gallery {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.preprocess();
    this.build();
    this.ready();
  }

  preprocess() {
    this.$element.find('.node').each((i, element) => {
      // Add background image from first/main image attached to post.
      element.BackgroundImage = new BackgroundImage(element);
      // Add associated type to the header for ease of styling hero slide.
      $(element).find('.node-header').prepend($(element).find('.associated'));
    });
  }

  build() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
